'use client'

import React from "react";
import './Button.css';

interface ButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
  url?: string;
  arialabel?: string;
  isSubmit?: boolean; // Propriedade para controlar o tipo do botão
  formId?: string; // Propriedade para o ID do formulário a ser enviado
  children?: React.ReactNode;
  scrollToTop?: boolean;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({ text, onClick, className, url, arialabel, isSubmit, formId, children, scrollToTop = true, disabled = false }) => {
  const handleSubmit = () => {
    // Caso o botão não seja do tipo submit, mas tenha o ID de um formulário, submete o formulário manualmente
    if (formId) {
      const formElement = document.getElementById(formId) as HTMLFormElement;
      if (formElement) {
        formElement.submit();
      }
    } else if (onClick) {
      onClick();
    }

    //Redireciona para o topo da página
    if (scrollToTop) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <button
      onClick={handleSubmit}
      className={`${className}`}
      link-url={url}
      aria-label={arialabel}
      type={isSubmit ? "submit" : "button"}
    >
      {children}
      {text}      
    </button>
  );
};

export default Button;
